import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { Redirect, useHistory, useLocation } from "react-router-dom";

interface IDistributorsContext {
    isLoading: boolean
    distributors: IDistributor[]
    recordCount: number
    search: ISearch

    doSearch: () => void
    handleChangePage: (event: any, page: number) => void
    deleteDistributor: (id: string) => void
    updateSearch: (newSearch: ISearch) => void
}

export let distributorsContext = React.createContext({} as IDistributorsContext);

let { Provider } = distributorsContext;

interface ISearch {
    searchText: string
    pageNr: number
    pageSize: number
}

interface IDistributor {
    id: string
    email: string
    firstName: string
    lastName: string
    companyName: string
    existInCognito: boolean
    countries: string[]
}

let VitecUserListProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { enqueueSnackbar } = useSnackbar();
    let location = useLocation();
    let history = useHistory();

    let [isLoading, setLoading] = useState(true);
    let [distributors, setDistributors] = useState<IDistributor[]>([]);
    let [recordCount, setTotalRecords] = useState(0);
    let [search, setSearch] = useState<ISearch>({
        pageNr: 0,
        pageSize: 20,
        searchText: '',
    });


    useEffect(() => {
        if (location.state)
            processState(location.state);
    }, [location.state])

    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        if (state.search) {
            setSearch({
                ...search,
                ...state.search
            })
        }

        searchDistributors({
            ...search,
            ...state.search
        });
    }

    let doSearch = () => {
        let request = {
            ...search,
            pageNr: search.pageNr > 0 ? 0 : search.pageNr
        }

        history.push(location.pathname, { search: request });
    }

    let searchDistributors = async (values: ISearch) => {
        try {
            setLoading(true);
            let res = await axios.post('/api/User/SearchDistributors', search)
            setDistributors(res.data.items);
            setTotalRecords(res.data.recordCount);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let updateSearch = (newSearch: ISearch) => {
        setSearch(newSearch);
    }

    let handleChangePage = (event: any, page: number) => {
        setSearch({
            ...search,
            pageNr: page
        });
    }

    let deleteDistributor = async (id: string) => {
        if (window.confirm("Are you sure that you want to delete this user?")) {
            try {
                await axios.delete(`/api/User/DeleteDistributor/${id}`);
                setDistributors(distributors.filter(user => user.id !== id));
                setTotalRecords(recordCount - 1);
                enqueueSnackbar('User deleted', { variant: 'success' });
            } catch (err) { }
        }
    }


    return (
        <Provider value={{
            isLoading,
            distributors,
            recordCount,
            search,

            doSearch,
            handleChangePage,
            deleteDistributor,
            updateSearch
        }}>
            {children}
        </Provider>
    );
};

export default VitecUserListProvider;